// Footer
import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export const Footer = ({ menusWidth, appType }) => {
    const theme = useTheme();

    return (
        <Box
            component="footer"
            sx={{
                marginLeft: `${menusWidth}px`,
                height: '38px',
                minHeight: '38px',
                mt: 'auto',
                backgroundColor: theme.palette.figma.mainBg,
            }}
        >
            <Toolbar sx={{
                backgroundColor: theme.palette.figma.block,
                minHeight: '38px !important',
                height: '38px',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Stack
                    direction="row"
                    width="100%"
                    justifyContent="flex-end"
                    alignItems="center"
                >
                    <Typography variant="body2" sx={{ fontSize: '12px' }}>
                        © 2025 Didim. All rights reserved.
                    </Typography>
                </Stack>
            </Toolbar>
        </Box >
    );
};
